<script setup lang="ts">
import useCurrentUserFavoriteComposable from '@src/favorite/composable/current-user-favorite-composable.ts';
import { addToast } from '@utils/toast-util';
import IconTooltip from '@components/icons/icon-tooltip.vue';

const { isCurrentRouteFavored, canAddToFavorites, addCurrentRouteToFavorites, removeCurrentRouteFromFavorites } = useCurrentUserFavoriteComposable();

function addOrRemoveCurrentRoute() {
    if (isCurrentRouteFavored.value) {
        removeCurrentRouteFromFavorites();
        addToast('Favorit gelöscht');
        return;
    }
    addCurrentRouteToFavorites();
    addToast('Favorit gespeichert');
}
</script>

<template>
    <IconTooltip
        v-if="canAddToFavorites"
        :class="[$style.favorite_button, isCurrentRouteFavored ? $style.is_current_route : '']"
        :tooltip="isCurrentRouteFavored ? 'Als Favorit entfernen' : 'Als Favorit markieren'"
        context="primary"
        position="right"
        icon="star"
        icon-color="inherit"
        @click="addOrRemoveCurrentRoute"
    />
</template>

<style module lang="scss">
@use '@backgrounds' as *;
@use '@text' as *;

.favorite_button {
    padding: .5em;
    background-color: #fff;
    border-right: 1px solid #afafaf;
    border-bottom: 1px solid #afafaf;

    svg {
        font-size: .8em;
    }
    &:hover {
        cursor: pointer;
    }
    &:hover,
    &.is_current_route {
        color: $primary-background;
        border-color: $primary-background;
    }
}
</style>
